import Vue from 'vue'
import VueRouter from "vue-router";
import routesNames from "../shared/constants/router";
import store from "../store/index"
import {MSALObj} from "../shared/services/ad_b2c/authRedirect";
import roles from "../shared/constants/roles";
import {hasAnyOfPermissions, hasRole, isSuperAdmin} from "../shared/services/permission";
import permissions from "../shared/constants/permissions";

Vue.use(VueRouter)

const ROUTER_VIEW_COMPONENT = {render(c) {return c("router-view")}}

const routes = [
  {
    path: "/",
    component: () => import("../components/layout/AppContainer"),
    meta: { auth: true },
    children: [
      {
        path: "select-role",
        name: routesNames.selectRole,
        component: () => import("../pages/select_role/index"),
        meta: {
          hasMultiRole: true,
          auth: true
        },
      },
      {
        path: "timesheets",
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            path: "",
            name: routesNames.timesheets,
            component: () => import("../pages/timesheets/timesheets_list/index"),
            meta: {
              permissions: [permissions.readTimesheetSummary],
              roles: [roles.WORKER, roles.APPROVER, roles.FREELANCER],
              auth: true
            },
          },
          {
            path: ":timesheet_status/timesheet-:timesheet_id-:nav_scope_id",
            props: true,
            name: routesNames.timesheetDetails,
            component: () => import("../pages/timesheets/timesheet_details/index"),
            meta: {
              permissions: [permissions.readTimesheetForm],
              roles: [roles.WORKER, roles.APPROVER, roles.FREELANCER],
              auth: true
            },
          }
        ]
      },
      {
        path: "invoices",
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            path: "",
            name: routesNames.invoices,
            component: () => import("../pages/invoices/invoices_list/index"),
            meta: {
              permissions: [permissions.readAllInvoices],
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN,roles.VENDOR],
              auth: true
            },
          },
          {
            path: "add",
            name: routesNames.addInvoice,
            component: () => import("../pages/invoices/add_invoice/index"),
            meta: {
              permissions: [permissions.readAllInvoices],
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN, roles.VENDOR],
              auth: true
            },
          },
          {
            path: "edit/:id",
            name: routesNames.editInvoice,
            component: () => import("../pages/invoices/edit_invoice/index"),
            meta: {
              permissions: [permissions.readAllInvoices],
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN, roles.VENDOR],
              auth: true
            },
          },
          {
            path: ":invoiceId",
            props: true,
            name: routesNames.invoiceDetails,
            component: () => import("../pages/invoices/invoice_details/index"),
            meta: {
              permissions: [permissions.readInvoice],
              auth: true
            },
          }
        ]
      },
      {
        path: "vendors/timesheets",
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            path: "",
            name: routesNames.vendortimesheets,
            component: () => import("../pages/vendor_timesheets/timesheets_list/index"),
            meta: {
              permissions: [permissions.readAllVendorTimesheets],
              auth: true
            },
          },
          {
            path: "add",
            name: routesNames.addTimesheet,
            component: () => import("../pages/vendor_timesheets/add_timesheet/index"),
            meta: {
              permissions: [permissions.readAllVendorTimesheets],
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN, roles.VENDOR],
              auth: true
            },
          },
          {
            path: "edit/:id",
            name: routesNames.editTimesheet,
            component: () => import("../pages/vendor_timesheets/edit_timesheet/index"),
            meta: {
              permissions: [permissions.readAllInvoices],
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN, roles.VENDOR],
              auth: true
            },
          },
          {
            path: ":timesheetId",
            props: true,
            name: routesNames.vendorTimesheetDetails,
            component: () => import("../pages/vendor_timesheets/timesheet_details/index"),
            meta: {
              permissions: [permissions.readVendorTimesheet],
              auth: true
            },
          }
        ]
      },
      {
        path: "scopes",
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            path: "",
            name: routesNames.administration.scopes,
            meta: {
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
              permissions: [permissions.readAllScopes],
              auth: true
            },
            component: () => import("../pages/scopes/scopes_list/index")
          },
          {
            path: ":scope_name-:scope_id",
            props: true,
            component: () => import("../pages/scopes/scope/index"),
            children: [
              {
                path: "",
                props: true,
                name: routesNames.administration.scopeDashboard,
                meta: {
                  roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/scope_dashboard/index"),
              },
              {
                path: "maintenance-configuration",
                props: true,
                name: routesNames.administration.maintenanceConfig,
                meta: {
                  permissions: [permissions.writeTranslation],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/scope_settings/index")
              },
              {
                path: "error-configuration",
                props: true,
                name: routesNames.administration.errorConfig,
                meta: {
                  permissions: [permissions.writeTranslation],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/scope_settings/index")
              },
              {
                path: "help-configuration",
                props: true,
                name: routesNames.administration.helpConfig,
                meta: {
                  permissions: [permissions.readHelpContents, permissions.writeHelpContents],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/help_configuration/index"),
              },
              {
                path: "policies",
                component: ROUTER_VIEW_COMPONENT,
                children:[
                  {
                    path: "",
                    props: true,
                    name: routesNames.administration.policies,
                    meta: {
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/policies/index"),
                  },
                  {
                    path: "terms-and-conditions",
                    props: true,
                    name: routesNames.administration.editTermsAndConditions,
                    meta: {
                      permissions: [permissions.readPrivacyAndTerms],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/policies/terms_and_conditions/editTermsAndConditions"),
                  },
                  {
                    path: "privacy-policy",
                    props: true,
                    name: routesNames.administration.editPrivacyPolicy,
                    meta: {
                      permissions: [permissions.readPrivacyAndTerms],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/policies/privacy_policy/editPrivacyPolicy"),
                  },
                ]
              },
              {
                path: "email-template-configuration",
                props: true,
                name: routesNames.administration.emailTemplate,
                meta: {
                  permissions: [permissions.readEmailTemplate],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/email_templates/dashboard/index"),
              },
              {
                path: "email-template-configuration/:type",
                props: true,
                name: routesNames.administration.editEmailTemplates,
                meta: {
                  permissions: [permissions.readEmailTemplate],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/email_templates/index"),
              },
              {
                path: "nav-credentials",
                props: true,
                name: routesNames.administration.navCredentials,
                meta: {
                  permissions: [
                    permissions.readScope,
                    permissions.readScopeNavCredentials
                  ],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/nav_credentials/index"),
              },
              {
                path: "mail-credentials",
                props: true,
                name: routesNames.administration.mailCredentials,
                meta: {
                  permissions: [
                    permissions.readScope,
                    permissions.readScopeMailCredentials
                  ],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/mail_credentials/index"),
              },
              {
                path: "emails",
                props: true,
                name: routesNames.administration.scopeEmails,
                meta: {
                  permissions: [
                    permissions.readScope,
                    permissions.readScopeEmails
                  ],
                  auth: true
                },
                component: () => import("../pages/scopes/scope/emails/index"),
              },
              {
                path: "connectivity",
                component: ROUTER_VIEW_COMPONENT,
                children: [
                  {
                    path: "",
                    props: true,
                    name: routesNames.administration.connectivityTest,
                    meta: {
                      permissions: [
                        permissions.readScope,
                        permissions.readScopeMailCredentials
                      ],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/connectivity_test/index"),
                  }
                ]
              },
              {
                path: "monitoring",
                component: ROUTER_VIEW_COMPONENT,
                children: [
                  {
                    path: "",
                    props: true,
                    name: routesNames.administration.monitoringJobs,
                    meta: {
                      permissions: [
                        permissions.readScope,
                        permissions.readScopeMailCredentials
                      ],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/connectivity_test/jobs"),
                  },
                  {
                    path: "last_jobs",
                    props: true,
                    name: routesNames.administration.lastJobs,
                    meta: {
                      permissions: [
                        permissions.readScope,
                        permissions.readScopeMailCredentials
                      ],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/connectivity_test/jobsMonitoring"),
                  },
                  {
                    path: "pending_jobs",
                    props: true,
                    name: routesNames.administration.pendingJobs,
                    meta: {
                      permissions: [
                        permissions.readScope,
                        permissions.readScopeMailCredentials
                      ],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/connectivity_test/jobsPending"),
                  },
                  {
                    path: "failed_jobs",
                    props: true,
                    name: routesNames.administration.failedJobs,
                    meta: {
                      permissions: [
                        permissions.readScope,
                        permissions.readScopeMailCredentials
                      ],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/connectivity_test/jobsFailed"),
                  },
                  {
                    path: "failed_jobs_launched",
                    props: true,
                    name: routesNames.administration.failedJobsLaunched,
                    meta: {
                      permissions: [
                        permissions.readScope,
                        permissions.readScopeMailCredentials
                      ],
                      roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/connectivity_test/failedJobsLaunched"),
                  }
                ]

              },
                {
                    path: "timesheetConfig",
                    props: true,
                    name: routesNames.administration.timesheetConfig,
                    meta: {
                        permissions: [permissions.writeTimesheetConfig],
                        auth: true
                    },
                    component: () => import("../pages/scopes/scope/timesheet_config/index")
                },
                {
                      path: "cronConfig",
                      props: true,
                      name: routesNames.administration.cronConfig,
                      meta: {
                          permissions: [permissions.writeCronConfig],
                          auth: true
                      },
                      component: () => import("../pages/scopes/scope/cron_config/index")
                  },
                  {
                      path: "cronConfig/:cron_name-:cron_id",
                      props: true,
                      name: routesNames.administration.editCronConfig,
                      meta: {
                          permissions: [permissions.writeCronConfig],
                          auth: true
                      },
                      component: () => import("../pages/scopes/scope/cron_config/EditCronConfig")
                  },
              {
                path: "sms",
                component: () => import("../pages/scopes/scope/sms/index"),
                children: [
                  {
                    path: "",
                    props: true,
                    name: routesNames.administration.sms,
                    meta: {
                      permissions: [permissions.readSmsHistory, permissions.readSmsTemplate, permissions.writeSmsTemplate],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/sms/dashboard/index")
                  },
                  {
                    path: "templates",
                    props: true,
                    name: routesNames.administration.smsTemplatesDashboard,
                    meta: {
                      permissions: [permissions.writeSmsTemplate, permissions.readSmsTemplate],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/sms/templates/dashboard/index")
                  },
                  {
                    path: "templates/:type?",
                    props: true,
                    name: routesNames.administration.smsTemplates,
                    meta: {
                      permissions: [permissions.writeSmsTemplate, permissions.readSmsTemplate],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/sms/templates/index")
                  },
                  {
                    path: "history",
                    props: true,
                    name: routesNames.administration.smsHistory,
                    meta: {
                      permissions: [permissions.readSmsHistory],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/sms/history/index")
                  },
                  {
                    path: "credentials",
                    props: true,
                    name: routesNames.administration.smsCredentials,
                    meta: {
                      permissions: [permissions.readScopeSmsCredentials, permissions.writeScopeSmsCredentials],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/sms/credentials/index")
                  },
                  {
                    path: "settings",
                    props: true,
                    name: routesNames.administration.smsSettings,
                    meta: {
                      permissions: [permissions.readSmsSettings, permissions.writeSmsSettings],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/sms/settings/index")
                  }
                ]
              },
              {
                path: "import-settings",
                component: () => import("../pages/scopes/scope/import_settings/index"),
                children: [
                  {
                    path: "",
                    props: true,
                    name: routesNames.administration.importColsMatching,
                    meta: {
                      permissions: [permissions.setImportCols],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/import_settings/dashboard/index")
                  },
                  {
                    path: "cols-timesheet",
                    props: true,
                    name: routesNames.administration.colsTimesheet,
                    meta: {
                      permissions: [permissions.setImportCols],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/import_settings/cols_timesheet/index")
                  },
                  {
                    path: "cols-invoice",
                    props: true,
                    name: routesNames.administration.colsInvoice,
                    meta: {
                      permissions: [permissions.setImportCols],
                      auth: true
                    },
                    component: () => import("../pages/scopes/scope/import_settings/cols_invoice/index")
                  },
                ]
              },
            ]
          },
        ]
      },
      {
        path: "help",
        name: routesNames.help.help,
        props: true,
        meta: {
          auth: true,
          permissions: [permissions.readHelpContents],
        },
        component: () => import("../pages/help_center/index")
      },
      {
        path: "users",
        meta: {
          permissions: [permissions.readAllUsers],
          auth: true
        },
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            name: routesNames.administration.users,
            path: "",
            component: () => import("../pages/user/index"),
          },
          {
            name: routesNames.administration.userDetails,
            path: ":user_id",
            props: true,
            component: () => import("../pages/user/UserDetails"),
          }
        ]
      },
      {
        path: "clients",
        meta: {
          permissions: [permissions.readAllClients],
          auth: true
        },
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            name: routesNames.administration.clients,
            path: "",
            component: () => import("../pages/client/index"),
          }
        ]
      },
      {
        path: "profile",
        name: routesNames.profile.profile,
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "email",
            name: routesNames.profile.email,
            meta: { auth: true },
            component: () => import("../pages/profile/email_edit/index")
          },
          {
            path: "details",
            name: routesNames.profile.details,
            meta: { auth: true },
            component: () => import("../pages/profile/personal_details/index")
          },
        ]
      },
      {
        path: "languages",
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            path: "",
            name: routesNames.administration.languages,
            meta: {
              permissions: [permissions.readLanguage],
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
              auth: true
            },
            component: () => import("../pages/language/index")
          },
          {
            path: "dictionary/:language_code-:language_name",
            name: routesNames.administration.dictionary,
            meta: {
              roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
              permissions: [permissions.writeTranslation],
              auth: true
            },
            component: () => import("../pages/language/Dictionary")
          },
        ]
      },
      {
        path: "permissions",
        name: routesNames.administration.permissions,
        meta: {
          permissions: [permissions.assignPermissions, permissions.readAllPermissions],
          auth: true
        },
        component: () => import("../pages/permission/index")
      },
      {
        path: "logs",
        name: routesNames.administration.logs,
        meta: {
          permissions: [permissions.readAllActivities],
          auth: true
        },
        component: () => import("../pages/scopes/scope/scope_logs/index")
      },
      {
        path: "jobsLogs",
        name: routesNames.administration.jobsLogs,
        meta: {
          permissions: [permissions.readAllActivities],
          auth: true
        },
        component: () => import("../pages/scopes/scope/scope_logs/commandLogs")
      },

      {
        path: "/terms-and-conditions",
        name: routesNames.administration.termsAndConditions,
        meta: { auth: false,
          permissions: [permissions.readPrivacyAndTerms],
        },
        component: () => import("../pages/scopes/scope/policies/terms_and_conditions/index")
      },
      {
        path: "/privacy-policy",
        name: routesNames.administration.privacyPolicy,
        meta: {
          auth: false,
          permissions: [permissions.readPrivacyAndTerms],
        },
        component: () => import("../pages/scopes/scope/policies/privacy_policy/index")
      },
      {
        path: "/not-allowed-page",
        name: routesNames.notAllowedPage,
        meta: {
          auth: false,
        },
        component: () => import("../pages/utils/NotAllowed"),
      },
      {
        path: "vendor",
        component: ROUTER_VIEW_COMPONENT,
        children: [
          {
            path: "",
            name: routesNames.vendorDashboard,
            component: () => import("../pages/vendor_timesheets/dashboard/index"),
            meta: {
              permissions: [permissions.readAllVendorTimesheets, permissions.readAllInvoices],
              auth: true
            },
          },
        ]
      },
    ]
  },
  {
    path: "/edit-email-callback",
    name: routesNames.editEmailCallback,
    meta: { auth: false },
    component: () => import("../pages/utils/EditEmailCallback") },
  {
    path: "/maintenance-page",
    meta: {
      auth: true, maintenance: true },
      name: routesNames.maintenancePage,

    component: () => import("../pages/utils/Maintenance"),
    props: true
  },
  {
    path: "/timesheet-approved/:token",
    props: true,
    name: routesNames.timesheetApproved,
    meta: { auth: false },
    component: () => import("../pages/timesheets/timesheet_details/TimesheetApproved")
  },
  {
    path: "/sign-up",
    meta: { auth: false },
    name: routesNames.signUp,
    component: () => import("../pages/signup/index"),
    beforeEnter: (to, from, next) => {
      if (to.query.token_hint && !store.getters["auth/isAuthenticated"]) {
        next();
      } else {
        next("/");
      }
    }
  },
  { path: "/500", name: routesNames.error500, component: () => import("../pages/utils/Page500") },
  { path: "/:catchAll(.*)", name: routesNames.error404, meta: { auth: false }, component: () => import("../pages/utils/Page404") },
]

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeResolve((to, from, next) => {

  // Check if user is trying to log as another user from another scope
  if (location.hash.length > 0 && location.hash.includes("loggedAs=")) {
    sessionStorage.setItem('loggedAsId', location.hash.replace("#loggedAs=", ""));
  }
  if (!MSALObj.interactionInProgress()) {

    if (store.getters["auth/isAuthenticated"]) {

      // Check if scope in maintenance
      if (to.matched.some(m => m.meta.maintenance) && !store.getters["auth/inMaintenance"]) {
        next("/");
      }

      // check if user is local admin and has one scope
      if (to.name === routesNames.administration.scopes) {
        const scope = store.getters["auth/allScopes"];
        if(scope.length === 1 && hasRole(roles.LOCAL_ADMIN)){
          router.replace({
            name: routesNames.administration.scopeDashboard,
            params: {
              scope_id: scope[0].id,
              scope_name: scope[0].name
            }
          });
          return;
        }
      }

      // Check if user has the right role
      if (to.meta.roles && !hasRole(to.meta.roles)) {
        Vue.$snotify.error("You need the right role", "Access denied");
        next("/");
      }

      // Check if user has the right permissions
      if (to.meta.permissions && !hasAnyOfPermissions(to.meta.permissions)) {
        next("/");
        Vue.$snotify.error("You need the right permissions", "Access denied");
      }

      // Check if user has multi role
      if (to.meta.hasMultiRole && !store.getters["auth/userHasMultiRole"]) {
        next("/");
        Vue.$snotify.error("You need the right permissions", "Access denied");
      }

      if (to.path !== '/select-role' && store.getters["auth/scopeDefault"].is_multirole_enabled && store.getters["auth/userHasMultiRole"] && store.getters["auth/connectedRole"] === null) {
        next("/select-role");
      }

      // Check if user has access to scope
      if (to.name === routesNames.administration.scopeDashboard && !hasScope(to.params.scope_id, to.params.scope_name)) {
        next(routesNames.administration.scopes);
      }

      next();

    } else {
      if(to.meta.auth === false){
        next();
      }
     else{
        store.dispatch("auth/signIn");
      }
    }

  }
});

function hasScope(scope_id, scope_name) {
  if (isSuperAdmin(store.getters["auth/role"])) {
    return true;
  }
  return store.getters["auth/allScopes"].findIndex(scope => { toString()
    return scope.id === parseInt(scope_id) && scope.name === scope_name
  }) > -1;
}

export default router
